import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { useInvalidateFolderEntitiesForEntity } from "@/queries/folder-entities/useInvalidateFolderEntitiesForEntity";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

interface UpdateWorkflowNameRequest {
  id: string;
  name: string;
  folder_id?: number | null;
}

interface UpdateWorkflowNameResponse {
  success: boolean;
}

export const useUpdateWorkflowName = () => {
  const userToken = useAuth()?.userToken ?? "";
  const queryClient = useQueryClient();
  const invalidateFolderEntities = useInvalidateFolderEntitiesForEntity();

  return useMutation<UpdateWorkflowNameResponse, unknown, UpdateWorkflowNameRequest>({
    mutationFn: async ({ id, name }) => {
      const response = await fetch(`${ENDPOINTS.workflows}/${id}`, {
        method: "PATCH",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify({ name }),
      });
      return handleResponse(response);
    },
    onSuccess: (res, variables) => {
      // eslint-disable-next-line no-empty
      if (!res.success) {
      }
      queryClient.invalidateQueries([ENDPOINTS.workflows]);
      invalidateFolderEntities(variables.folder_id ?? null);
    }, // eslint-disable-next-line @typescript-eslint/no-empty-function
    onError: () => {},
  });
};
